<!-- Text skeleton -->
@if (type === 'text') {
  @for (i of linesArray; track i) {
    <div
      class="skeleton skeleton-text"
      [ngClass]="[animationClass, variantClass]"
      [style.width.%]="getLineWidth(i)"
      [style.height.px]="height">
    </div>
  }
}

<!-- Paragraph skeleton (multiple lines with varied widths) -->
@if (type === 'paragraph') {
  @for (i of linesArray; track i) {
    <div
      class="skeleton skeleton-text"
      [ngClass]="[animationClass, variantClass]"
      [style.width.%]="getParagraphLineWidth(i)"
      [style.height.px]="height">
    </div>
  }
}

<!-- Title skeleton -->
@if (type === 'title') {
  <div
    class="skeleton skeleton-title"
    [ngClass]="[animationClass, variantClass]"
    [style.width.%]="width"
    [style.height.px]="height">
  </div>
}

<!-- Avatar skeleton -->
@if (type === 'avatar') {
  <div
    class="skeleton skeleton-avatar"
    [ngClass]="[animationClass, variantClass, 'skeleton-avatar-' + size]">
  </div>
}

<!-- Thumbnail skeleton -->
@if (type === 'thumbnail') {
  <div
    class="skeleton skeleton-thumbnail"
    [ngClass]="[animationClass, variantClass]"
    [style.height.px]="height || 120">
  </div>
}

<!-- Button skeleton -->
@if (type === 'button') {
  <div
    class="skeleton skeleton-button"
    [ngClass]="[animationClass, variantClass]"
    [style.width.px]="width || 100">
  </div>
}

<!-- Card skeleton -->
@if (type === 'card') {
  <div class="skeleton-card">
    <div class="skeleton skeleton-card-image" [ngClass]="[animationClass, variantClass]"></div>
    <div class="skeleton-card-body">
      <div class="skeleton skeleton-title skeleton-w-70" [ngClass]="[animationClass, variantClass]"></div>
      <div class="skeleton skeleton-text skeleton-w-100" [ngClass]="[animationClass, variantClass]"></div>
      <div class="skeleton skeleton-text skeleton-w-80" [ngClass]="[animationClass, variantClass]"></div>
    </div>
  </div>
}

<!-- Table row skeleton -->
@if (type === 'table-row') {
  <tr class="skeleton-table-row">
    @for (i of columnsArray; track i) {
      <td>
        <div class="skeleton skeleton-text" [ngClass]="[animationClass, variantClass]" [style.width.%]="60 + (i * 10) % 40"></div>
      </td>
    }
  </tr>
}
